import script from "./EnvironmentSqmNewXG.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentSqmNewXG.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentSqmNewXG.vue?vue&type=style&index=0&id=18561d23&scoped=true&lang=scss"
import "./EnvironmentSqmNewXG.vue?vue&type=style&index=1&id=18561d23&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18561d23"]])

export default __exports__